import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../../FluidSections";
import { Accordion, Card } from "./Accordion";
import { Img } from "../../../sharedComponents/Images";
import { cloudinaryImageToSrcUrlAdapter } from "../../../sharedComponents/CloudinaryImageAdapter";
import { Heading } from "../../Headings/Heading";
import * as styles from "./Accordion.module.scss";

const FluidAccordion = ({ title, activeKey, variant, cards, location, locale }) => (
	<div>
		{title && (
			<Heading as="h2" size="h4" className={classNames(styles.accordionTitle)}>
				{title}
			</Heading>
		)}
		<Accordion activeKey={activeKey} variant={variant}>
			{cards?.map(card => (
				<Card key={card.id} eventKey={card.cardKey}>
					<Card.Toggle>
						{card.image && (
							<Img
								src={cloudinaryImageToSrcUrlAdapter(card?.image?.[0])}
								wrapperClassName={classNames(styles.accordionImageWrapper)}
								alt={`Image of ${card.cardText}`}
							/>
						)}
						<div className={classNames(styles.accordionHeader)}>
							{card.cardText}
							{card.cardSubText && <span>{card.cardSubText}</span>}
						</div>
					</Card.Toggle>
					<Card.Panel>
						<FluidSections
							data={card.cardContentComponents}
							useWrapper={false}
							location={location}
							locale={locale}
						/>
					</Card.Panel>
				</Card>
			))}
		</Accordion>
	</div>
);

FluidAccordion.propTypes = {
	title: PropTypes.string,
	activeKey: PropTypes.string,
	variant: PropTypes.oneOf(["classic", "tide"]),
	cards: PropTypes.arrayOf(PropTypes.object),
	location: PropTypes.object,
	locale: PropTypes.string,
};
FluidAccordion.defaultProps = {
	title: "",
	activeKey: undefined,
	variant: "classic",
	cards: null,
	location: null,
	locale: null,
};

export default FluidAccordion;
export { FluidAccordion };
